export default __webpack_public_path__ + "static/media/testimonial-03.19d45cdf.jpg";